<template>
  <v-dialog
    v-model="showModal"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
    persistent
    @keydown.esc="closeModal"
  >
    <v-card class="project-detail-modal">
      <v-toolbar dark color="primary" class="no-hover-toolbar fixed-height-toolbar" height="64">
        <v-btn icon dark @click="closeModal" class="no-hover-btn action-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="text-h6 toolbar-title">
          Dettaglio Progetto{{ project ? ': ' + project.name : '' }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="action-buttons">
          <v-btn dark text @click="closeModal" class="no-hover-btn action-btn">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="pa-0 modal-content">
        <div v-if="project" class="pa-4">
          <detail-project-header :project="project"></detail-project-header>
          <detail-project-activities :project="project" @taskSaved="loadProject"/>
        </div>
        <div v-else class="d-flex justify-center align-center" style="height: 300px;">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
      </v-card-text>

      <!-- Footer con azioni -->
      <v-card-actions class="modal-footer pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="closeModal"
          class="mr-2"
        >
          <v-icon left>mdi-close</v-icon>
          Chiudi
        </v-btn>
        <v-btn
          color="primary"
          @click="refreshProject"
          :loading="loadingRefresh"
        >
          <v-icon left>mdi-refresh</v-icon>
          Aggiorna
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DetailProjectHeader from "../views/projects/DetailProjectHeader.vue";
import DetailProjectActivities from "../views/projects/DetailProjectActivities.vue";

export default {
  components: {
    DetailProjectHeader,
    DetailProjectActivities
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      project: null,
      loadingRefresh: false
    };
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    projectId: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.showModal) {
          this.loadProject();
        }
      }
    },
    showModal(val) {
      if (val && this.projectId) {
        this.loadProject();
      } else if (!val) {
        // Quando la modale viene chiusa, aggiorniamo l'URL
        this.updateUrl();
      }
    }
  },
  methods: {
    loadProject() {
      if (!this.projectId) return;

      this.project = null; // Reset per mostrare il loader

      this.$projectService.get(this.projectId, {detail: ''})
        .then(resp => {
          this.project = resp.data;
        })
        .catch(err => {
          console.error('Errore nel caricamento del progetto:', err);
          this.$dtoast.pop({
            preset: "error",
            content: "Errore nel caricamento del progetto",
          });
          this.closeModal();
        });
    },
    closeModal() {
      this.showModal = false;
      this.project = null;
    },
    updateUrl() {
      // Aggiorniamo l'URL senza ricaricare la pagina
      if (this.$route.name !== 'projects') {
        this.$router.push({ name: 'projects' });
      }
    },
    refreshProject() {
      this.loadingRefresh = true;
      this.loadProject();
      // Il loading verrà disattivato automaticamente quando loadProject() completa
      setTimeout(() => {
        this.loadingRefresh = false;
      }, 1000);
    }
  }
};
</script>

<style>
.project-detail-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-content {
  flex: 1;
  overflow: auto;
}

/* Stile per il footer della modale */
.modal-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
  background-color: #fafafa !important;
  min-height: 64px !important;
  flex-shrink: 0 !important;
}

.modal-footer .v-btn {
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}

/* Rimuove angoli stondati dalla modale fullscreen */
.project-detail-modal {
  border-radius: 0 !important;
}

.project-detail-modal .v-card {
  border-radius: 0 !important;
}

/* Fissa l'altezza dell'header della modale */
.fixed-height-toolbar {
  min-height: 64px !important;
  max-height: 64px !important;
  height: 64px !important;
}

.fixed-height-toolbar .v-toolbar__content {
  height: 64px !important;
  min-height: 64px !important;
  max-height: 64px !important;
  padding: 0 16px !important;
  align-items: center !important;
}

/* Ottimizzazione layout pulsanti azioni */
.fixed-height-toolbar .toolbar-title {
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: calc(100vw - 200px) !important;
}

.fixed-height-toolbar .action-btn {
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
  margin: 0 4px !important;
}

.fixed-height-toolbar .action-buttons {
  height: 48px !important;
  align-items: center !important;
}

.fixed-height-toolbar .action-buttons .action-btn {
  height: 48px !important;
  line-height: 48px !important;
  padding: 0 16px !important;
  font-weight: 500 !important;
}

/* Rimuove effetti hover dai pulsanti nell'header */
.no-hover-toolbar .no-hover-btn:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.no-hover-toolbar .no-hover-btn:hover::before {
  opacity: 0 !important;
}

.no-hover-toolbar .no-hover-btn {
  transition: none !important;
}
</style>
